import script from "./DetailPageEN.vue?vue&type=script&setup=true&name=DetailPage&lang=js"
export * from "./DetailPageEN.vue?vue&type=script&setup=true&name=DetailPage&lang=js"

import "./DetailPageEN.vue?vue&type=style&index=0&id=460ae6c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-460ae6c8"]])

export default __exports__